import { isSrmUpdateNewer } from "./srmVersion";

export function watchDeployedVersion({ current, onNewer, fetchVersion = window.fetch.bind(window), intervalMs = 60000, baseUrl = process.env.PUBLIC_URL || "" }) {
  let stopped = false;
  let pending = false;
  const check = async () => {
    if (stopped || pending) return;
    pending = true;
    try {
      const response = await fetchVersion(`${baseUrl}/version.json?t=${Date.now()}`, { cache: "no-store", credentials: "same-origin" });
      if (!response.ok) return;
      const version = await response.json();
      if (!stopped && typeof version?.version === "string" && Number.isSafeInteger(version.build_no)
        && isSrmUpdateNewer(version, current)) onNewer(version);
    } catch { /* Network loss/missing version file is not proof of a new build. */ }
    finally { pending = false; }
  };
  const onFocus = () => { if (document.visibilityState === "visible") check(); };
  check();
  const timer = setInterval(check, intervalMs);
  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onFocus);
  return () => { stopped = true; clearInterval(timer); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onFocus); };
}
